import { createFileRoute } from '@tanstack/react-router';
import DiceRoller from 'src/pages/Organization/DiceRoller';

export const Route = createFileRoute(
  '/$organizationSlug/mechanics/dice_roller/',
)({
  component: DiceRoller,
});
